import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoginPageComponent } from './login-page/login-page.component';

export const routing: ModuleWithProviders = RouterModule.forChild([
  { path: 'login', component: LoginPageComponent }
]);

